<template>
  <div class="footer">
    <!-- <span style="font-size: 16px; font-weight: 400">联系方式:18083721326</span> -->
    <footer>
      <el-row class="connectWay">
        <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
          联系方式:18083721326
        </el-col>
        <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">座机:0523-81559299</el-col>
        <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">邮箱:57970814@qq.com</el-col>
        <el-col :xs="12" :sm="12" :md="4" :lg="5" :xl="4">地址:江苏省泰州市高港区港城西路3号</el-col>
      </el-row>
      <el-row class="line">
        <el-col :xs="23" :sm="23" :md="18" :lg="18" :xl="18"></el-col>
      </el-row>
      <el-row class="bah">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">泰州市峰润洗涤服务有限公司</el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">苏ICP备2021015298号-1</el-col>
      </el-row>
    </footer>
  </div>
</template>

<script>
export default {
  name: "ComponentFooter",
};
</script>

<style scoped lang="less">
.footer {
  background: #1f948d;
  color: #fff;
  font-size: 0.08rem;
  padding: 22px 0 20px 0;
  box-sizing: border-box;

  footer {
    .connectWay {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0 8px;
    }

    .line {
      display: flex;
      justify-content: center;
      margin: 22px 0 20px 0;

      .el-col {
        border-bottom: 1px dashed #707070;
      }
    }

    .bah {
      .el-col {
        text-align: center;

        &:last-child {
          margin-top: 10px;
          font-size: 0.07rem;
        }
      }
    }
  }
}
</style>
